import axios, { AxiosInstance } from 'axios'
import { keyBy, orderBy } from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import Vuex from 'vuex'

import { Dictionary } from 'vue-router/types/router'

import { postgrestFactory } from '@/components/artifacts/module'
import { factory } from '@/components/registration/module'

import caseMessageModule from './casemessages-module'
import casesModule from './cases-module'
import interviewModule from './interview'
import { factory as restModule } from './RestFactory'
import workflowModule from './workflow'
//import createPersistedState from 'vuex-persistedstate'

// import bookingsModule from './interview/bookings'
// import processModule from '@/components/process-management/module'

Vue.use(Vuex)

export interface Letter {
  type: 'letter'
  published_at: string
  sender_id: string
  submitter_id: undefined
  code: string
}

export const isLetter = (o: Letter | DiaryEntry): o is Letter => {
  return typeof (o as Letter).code === 'string'
}

export interface DiaryEntry {
  type: 'conflict' | 'relationship' | 'situation' | 'activity' | 'reframing' | 'thought'
  published_at: string
  submitter_id: string
  sender_id: undefined
}

interface UserAttributes {
  username: string
  email: string
  password: string
  password_confirmation: string
}

export const supportedLanguages = ['de', 'ar']

export const store = new Vuex.Store<{
  currentLocale: string
}>({
  state() {
    /*
    let currentLocale: string = localStorage.getItem('currentLocale') || navigator.language || 'ar'
    if (!supportedLanguages.includes(currentLocale)) {
      currentLocale = 'ar'
    }
    */
    const currentLocale = localStorage.getItem('currentLocale') || 'ar'
    localStorage.setItem('currentLocale', currentLocale)
    return { currentLocale }
  },
  getters: {
    currentLocale: state => state.currentLocale,
    loading: (state, getters, rootState, rootGetters): boolean => {
      return (
        // rootGetters['demographics/loading'] ||
        // rootGetters['inep/loading'] ||
        // rootGetters['bdi2/loading'] ||
        // rootGetters['comment/loading'] ||
        // rootGetters['eurohis/loading'] ||
        // rootGetters['gad7/loading'] ||
        // rootGetters['mspss/loading'] ||
        // rootGetters['pcl5/loading'] ||
        // rootGetters['pg13/loading'] ||
        // rootGetters['phq15/loading'] ||
        // rootGetters['lec5/loading'] ||
        // rootGetters['pmbs/loading'] ||
        // rootGetters['wai/loading'] ||
        // rootGetters['trgi/loading'] ||
        // rootGetters['taq/loading'] ||
        // rootGetters['sewip/loading'] ||
        // rootGetters['traumaliste/loading'] ||
        // rootGetters['disclosure/loading'] ||
        // rootGetters['evaluation/loading'] ||
        rootGetters['iptConflicts/loading'] ||
        rootGetters['iptRelationships/loading'] ||
        rootGetters['iptSituations/loading'] ||
        rootGetters['cbtActivities/loading'] ||
        rootGetters['cbtReframings/loading'] ||
        rootGetters['cbtThoughts/loading'] ||
        // rootGetters['lsas/loading'] ||
        // rootGetters['pathev/loading'] ||
        // rootGetters['phq9/loading'] ||
        // rootGetters['interviewReports/loading'] ||
        // rootGetters['feedbackInterviewReports/loading'] ||
        rootGetters['letterTemplates/loading'] ||
        rootGetters['letters/loading'] ||
        rootGetters['workflow/loading']
      )
    },
    pastLetters(state, getters, rootState, rootGetters) {
      //console.log("SelectCaseId: ", rootGetters.currentCaseId)
      return rootGetters.pastLettersForMembersAndCaseId(
        rootGetters.currentCaseMembers,
        rootGetters.currentCaseId
      )
    },
    pastLettersForMembersAndCaseId: (state, getters, rootState, rootGetters) => {
      return (caseMembers: any[], caseId: string) => {
        const members = keyBy(caseMembers, 'userId')

        const letters: Array<Omit<Letter, 'type'>> =
          rootGetters['letters/filterBy']({ case_id: caseId }) || []
        const conflicts: Array<Omit<DiaryEntry, 'type'>> =
          rootGetters['iptConflicts/filterBy']({ case_id: caseId }) || []
        const relationships: Array<Omit<DiaryEntry, 'type'>> =
          rootGetters['iptRelationships/filterBy']({ case_id: caseId }) || []
        const situations: Array<Omit<DiaryEntry, 'type'>> =
          rootGetters['iptSituations/filterBy']({ case_id: caseId }) || []
        const activities: Array<Omit<DiaryEntry, 'type'>> =
          rootGetters['cbtActivities/filterBy']({ case_id: caseId }) || []
        const reframings: Array<Omit<DiaryEntry, 'type'>> =
          rootGetters['cbtReframings/filterBy']({ case_id: caseId }) || []
        const thoughts: Array<Omit<DiaryEntry, 'type'>> =
          rootGetters['cbtThoughts/filterBy']({ case_id: caseId }) || []

        //console.log('filtered Letters for caseId:', caseId, ' is: ', letters)
        //console.log('entities', rootGetters['letters/storedObjectsArray'])
        /*console.log(
          'entities',
          filterBy(rootGetters['letters/storedObjectsArray'], { case_id: caseId })
        )*/

        const mixed: Array<Letter | DiaryEntry> = orderBy(
          [
            ...letters.map(letter => ({ type: 'letter' as 'letter', ...letter })),
            ...conflicts.map(letter => ({ type: 'conflict' as 'conflict', ...letter })),
            ...relationships.map(letter => ({ type: 'relationship' as 'relationship', ...letter })),
            ...situations.map(letter => ({ type: 'situation' as 'situation', ...letter })),
            ...activities.map(letter => ({ type: 'activity' as 'activity', ...letter })),
            ...reframings.map(letter => ({ type: 'reframing' as 'reframing', ...letter })),
            ...thoughts.map(letter => ({ type: 'thought' as 'thought', ...letter })),
          ].filter(e => !!e.published_at),
          ['published_at'],
          ['desc']
        )

        //console.log('mixed', mixed)

        return mixed.map(exercise => {
          if (exercise.type === 'letter') {
            return {
              ...exercise,
              by: members[exercise.sender_id] || {},
              by_me: exercise.sender_id === rootGetters.currentUserId,
              published_at: moment(exercise.published_at),
            }
          } else {
            return {
              ...exercise,
              by: members[exercise.submitter_id] || {},
              by_me: exercise.sender_id === rootGetters.currentUserId,
              published_at: moment(exercise.published_at),
            }
          }
        })
      }
    },
    loadingModules: (state, getters, rootState, rootGetters) => {
      const modules: string[] = []
      if (rootGetters['iptConflicts/loading']) {
        modules.push('iptConflicts')
      }
      if (rootGetters['iptRelationships/loading']) {
        modules.push('iptRelationships')
      }
      if (rootGetters['iptSituations/loading']) {
        modules.push('iptSituations')
      }
      if (rootGetters['cbtActivities/loading']) {
        modules.push('cbtActivities')
      }
      if (rootGetters['cbtReframings/loading']) {
        modules.push('cbtReframings')
      }
      if (rootGetters['cbtThoughts/loading']) {
        modules.push('cbtThoughts')
      }
      if (rootGetters['letterTemplates/loading']) {
        //console.log('Loading letter-Templates')
        modules.push('letterTemplates')
      }
      if (rootGetters['letters/loading']) {
        modules.push('letters')
      }
      if (rootGetters['workflow/loading']) {
        modules.push('workflow')
      }
      return modules
    },
  },
  mutations: {
    changeLocale(state, { locale }: { locale: string }) {
      if (supportedLanguages.indexOf(locale) === -1) {
        throw new Error('unsupported locale, choose one of ar or de')
      }
      state.currentLocale = locale
      localStorage.setItem('currentLocale', locale)
    },
  },
  actions: {
    changeLocale({ commit }, { locale }: { locale: string }) {
      return commit({ type: 'changeLocale', locale })
    },
  },
  modules: {
    messages: {
      namespaced: true,
      ...caseMessageModule,
    },
    cases: casesModule,
    demographics: restModule({ url: '/api/demographics', autoFetchOnSignIn: true }),
    inep: restModule({ url: '/api/inep' }),
    interview: {
      namespaced: true,
      ...interviewModule,
    },
    interviewReports: postgrestFactory({
      baseUrl: '/api/interview_reports',
      namespaced: true,
      pullOnSignIn: true,
    }),
    feedbackInterviewReports: postgrestFactory({
      baseUrl: '/api/feedback_interview_reports',
      namespaced: true,
      pullOnSignIn: true,
    }),
    // surveys
    bdi2: restModule({ url: '/api/bdi2' }),
    comment: restModule({ url: '/api/comment' }),
    eurohis: restModule({ url: '/api/eurohis' }),
    scaling: restModule({ url: '/api/scaling' }),
    gad7: restModule({ url: '/api/gad7' }),
    mspss: restModule({ url: '/api/mspss' }),
    pcl5: restModule({ url: '/api/pcl5' }),
    pg13: restModule({ url: '/api/pg13' }),
    phq15: restModule({ url: '/api/phq15' }),
    lec5: restModule({ url: '/api/lec5', autoFetchOnSignIn: true }),
    pmbs: restModule({ url: '/api/pmbs' }),
    wai: restModule({ url: '/api/wai' }),
    trgi: restModule({ url: '/api/trgi' }),
    taq: restModule({ url: '/api/taq' }),
    sewip: restModule({ url: '/api/sewip' }),
    traumaliste: restModule({ url: '/api/traumaliste', autoFetchOnSignIn: true }),
    disclosure: restModule({ url: '/api/disclosure' }),
    evaluation: restModule({ url: '/api/evaluation' }),
    // ipt exercises
    iptConflicts: restModule({ url: '/api/ipt_conflicts', autoFetchOnSignIn: true }),
    iptRelationships: restModule({ url: '/api/ipt_relationships', autoFetchOnSignIn: true }),
    iptSituations: restModule({ url: '/api/ipt_situations', autoFetchOnSignIn: true }),
    // cbt exercises
    cbtActivities: restModule({ url: '/api/cbt_activities', autoFetchOnSignIn: true }),
    cbtReframings: restModule({ url: '/api/cbt_reframings', autoFetchOnSignIn: true }),
    cbtThoughts: restModule({ url: '/api/cbt_thoughts', autoFetchOnSignIn: true }),
    // letters
    letterTemplates: postgrestFactory({
      baseUrl: '/api/letter_templates',
      namespaced: true,
      pullOnSignIn: true,
    }),
    letters: postgrestFactory({
      baseUrl: '/api/letters',
      namespaced: true,
      pullOnSignIn: true,
    }),
    myMessages: postgrestFactory({
      baseUrl: '/api/my_messages',
      namespaced: true,
      pullOnSignIn: true,
    }),
    lsas: restModule({ url: '/api/lsas' }),
    pathev: restModule({ url: '/api/pathev' }),
    phq9: restModule({ url: '/api/phq9' }),
    registration: factory({ baseUrl: '/api/auth' }),
    workflow: {
      namespaced: true,
      ...workflowModule,
    },
  },
  plugins: [s => s.dispatch('INITIALIZE_STORE')],
})

export default store

let intervalId: number = 0

if (intervalId) {
  window.clearInterval(intervalId)
}

intervalId = window.setInterval(() => {
  //store.dispatch({ type: 'messages/query' })
  store.dispatch({ type: 'myMessages/pullObjects', setLoading: false })
}, 60 * 1000)
